/**
 * @module core
 */

import Sdk from "./Sdk";

// Export common types that should be available at the project root level
export { Success, SuccessResult, ErrorResult, SdkInitOptions } from "./types";
export { ERROR_CODES, METHOD_STATUSES, SDK_MODULES } from "./constants";
export { App } from "@/constants";

/**
 * Initialize the Growave application with the specified options.
 *
 * @example
 *
 * Ensure the SDK is ready, then call `init` to initialize Growave application.
 *
 * ```javascript
 * function onSdkReady() {
 *   window.gw.sdk.init({
 *     enabledApps: [
 *       window.gw.sdk.common.constants.apps.INSTAGRAM,
 *       window.gw.sdk.common.constants.apps.QUESTIONS,
 *       window.gw.sdk.common.constants.apps.REVIEWS,
 *       window.gw.sdk.common.constants.apps.REWARDS,
 *       window.gw.sdk.common.constants.apps.TIKTOK,
 *       window.gw.sdk.common.constants.apps.WISHLISTS,
 *     ],
 *     myshopifyDomain: "my-shop.myshopify.com",
 *     storefrontApiAccessToken: "your_storefront_api_access_token",
 *     // Additional optional properties are defined in the `SdkInitOptions` interface
 *   });
 * }
 *
 * if (window.gw && window.gw.sdk) {
 *   onSdkReady();
 * } else {
 *   document.addEventListener("gwSdkReady", onSdkReady);
 * }
 * ```
 *
 * @param options - Configuration options for SDK initialization
 *
 * @function
 */
export const init = Sdk.prototype["init"];

/**
 * @function
 */
export const on = Sdk.prototype["on"];

/**
 * @function
 */
export const off = Sdk.prototype["off"];

/**
 * @function
 */
export const runIfModuleReady = Sdk.prototype["runIfModuleReady"];
